import { CartItemDescription } from "./cartItemDescription"
import { CartItemImage } from "./cartItemImage"
import { CartItemQuantity } from "./cartItemQuantity"
import styles from "./style.module.css"
import {ICartItemDescriptionProp} from "./cartItemDescription"
import { ICartItemQuantity } from "./cartItemQuantity"

interface ICartItemProps{
  itemImage: string,
  itemDesc: ICartItemDescriptionProp,
  // onRemoveItem: (index: number) => void,
  itemQty: ICartItemQuantity
}



export const CartItem = ({itemDesc, itemImage, itemQty/* , onRemoveItem */}:ICartItemProps) =>{


     return (
       <div className={styles.container}>
         
         <div className={styles.itemImageContainer}>
           <CartItemImage itemImage={itemImage} />
         </div>

         <CartItemDescription {...itemDesc} />
         <CartItemQuantity
           handleClick={itemQty.handleClick}
           index={itemQty.index}
         />
       </div>
     );

}